module.exports = __webpack_public_path__ + "static/img/top_image1.fdad25a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/top_image1.png
// module id = 4XYl
// module chunks = 0